import { render, staticRenderFns } from "./complaintDetailList.vue?vue&type=template&id=2023071e&scoped=true"
import script from "./complaintDetailList.vue?vue&type=script&lang=js"
export * from "./complaintDetailList.vue?vue&type=script&lang=js"
import style0 from "./complaintDetailList.vue?vue&type=style&index=0&id=2023071e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023071e",
  null
  
)

export default component.exports